import ApplicationModel, { attr } from '../ApplicationModel';
import { type ProjectStrategyComponentAttributes } from './generated/ProjectStrategyComponentAttributes';
import { model } from '../modelBuilder';

interface ProjectStrategyComponent extends ProjectStrategyComponentAttributes {}

@model
class ProjectStrategyComponent extends ApplicationModel {
  // Start auto-generated
  static typename: 'ProjectStrategyComponent' = 'ProjectStrategyComponent';
  get typename(): 'ProjectStrategyComponent' {
    return 'ProjectStrategyComponent';
  }

  static internalTypename: 'ProjectStrategyComponent' =
    'ProjectStrategyComponent';
  get internalTypename(): 'ProjectStrategyComponent' {
    return 'ProjectStrategyComponent';
  }

  static fields = {
    id: attr({ readable: true }),
    name: attr({ readable: true }),
    tasks: attr.hasMany({ readable: true }),
  };
  // End auto-generated
}

export default ProjectStrategyComponent;
